import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const HeaderRowContainer = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 0.5rem;
	width: auto;

	> button {
		body[dir='rtl'] & {
			.button-icon {
				transform: scaleX(-1);
			}
		}
	}
`;
export const HeaderContainerFormHeader = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	background-color: var(--white);
	margin: -2.5rem -2.5rem var(--margin-5) -2.5rem;
	width: -webkit-fill-available;
	padding: 1rem 3rem;
	border-bottom: 1px solid var(--border-color);
	border-radius: 0 0 var(--small-border-radius) var(--small-border-radius);
	top: 0;
	min-height: 6.15rem;
	gap: 1rem;
	flex: 0 0 auto;

	@media ${Breakpoints.tablet} {
		div.progressWizardFullscreen {
			display: none;
		}
	}

	@media ${Breakpoints.mobile} {
		margin: 0 -2.5rem var(--margin-5) -2.5rem;
		padding: 1rem 4rem;
	}
`;
export const HeaderColumnContent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
`;

export const HeaderContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
`;

export const HeaderIconContainer = styled.div`
	align-self: start;
	margin-top: var(--margin-1);
	margin-right: var(--margin-3);
	color: var(--black);

	body[dir='rtl'] & {
		margin-right: unset;
		margin-left: var(--margin-3);
	}
`;

export const Header = styled.div`
	display: inline-block;
	width: 80%;
	margin-bottom: var(--margin-2);
`;

export const TitleCss = css`
	font-size: var(--paragraph1-font-size);
	font-weight: 500;
	color: var(--black);
	margin-bottom: var(--margin-2);
`;

export const SubtitleCss = css`
	font-size: var(--paragraph3-font-size);
	margin-bottom: var(--margin-1);
	color: var(--black);
	opacity: 0.6;
`;
